import { useEffect, useState } from 'react';
import References from '../../helpers/Reference';
import AuthService from './auth.modules.js';
import { useAuth } from './store';
import { jwtDecode } from 'jwt-decode';

import { LoadingOutlined, UserOutlined, UnlockOutlined, LoginOutlined, LogoutOutlined, SettingOutlined } from '@ant-design/icons';
import { Input, Button, Modal, Alert, Dropdown } from 'antd';

import IcoProfile from '../../images/ico_profile.svg';
import IcoEnter from '../../images/ico_enter.svg';

import { Button as CustomButtom } from '../Buttons/button';
import { fromRefByDomain } from '../../helpers/helpers.js';
import { useSubdomains } from '../Subdomains/store.js';
import { clearStationFilters } from '../../helpers/helpers.js';
import { UserSettingsModal } from './UserSettingsModal';

export const Auth = () => {

    const [ login, setLogin ] = useState('');    
    const [ password, setPassword] = useState('');

    const { isAuth, permission, authError, isAuthorized, isExpired } = useAuth();
    const {subdomainSettings, isPresetExist} = useSubdomains()

    const [ isShowAuthWindow, setIsShowAuthWindow ] = useState( !isAuth );
    const [ isShowSettingsWindow, setIsShowSettingsWindow ] = useState( false );
    
    useEffect(() => {
        if (!isAuth ) {
            setIsShowAuthWindow( true );
        }
    }, 
    [isAuth]);

    const onShowSettingsWindow = () => {
        setIsShowSettingsWindow( true );
    }

    const onHideSettingsWindow = () => {
        setIsShowSettingsWindow( false );
    }

    const onLoginButtonClick = ( l, p ) => {
            useAuth.setState({isAuthorized: true});
            AuthService.login( l, p )
            .then(data => {
                AuthService.afterLogon(data, setIsShowAuthWindow, setIsShowAuthWindow, false, true)
            })
    }

    const onAnonimusLoginButtonClick = () => {
        let l = fromRefByDomain(['default_user', 'user'], subdomainSettings);
        let p = fromRefByDomain(['default_user', 'password'], subdomainSettings);//References.anonimus.password;            
        onLoginButtonClick(l, p);           
        clearStationFilters();                     
    }

    const onLogoutButtonClick = () => {
    	AuthService.logout();
        useAuth.setState({isAuth: false});
        setIsShowAuthWindow( true );        
        clearStationFilters();
    }

    const onLogoutAllButtonClick = () => {
    	AuthService.logoutAll();
        useAuth.setState({isAuth: false});
        setIsShowAuthWindow( true );                
    }

    const onShowAuthWindow = () => {
        setIsShowAuthWindow( true );
    }

    const onHideAuthWindow = () => {
        setIsShowAuthWindow( false );
    }

    const authMenuItems = [
        {
            key: 'settings',
            label: 'Настройки',
            icon: <SettingOutlined />,
            onClick: onShowSettingsWindow
        },
        {
            key: 'logout',
            label: 'Выйти',
            icon: <LogoutOutlined />,
            onClick: onLogoutButtonClick
        },
        {
            key: 'logout-all',
            label: 'Выйти на всех устройствах',
            icon: <LogoutOutlined />,
            onClick: onLogoutAllButtonClick
        }
    ];

    if (subdomainSettings?.default_user?.default_user_only)
        return
            <></>;

    return (
        <>
            <Modal 
                title="Авторизация" 
                open={isShowAuthWindow} 
                onCancel={onHideAuthWindow}
                footer={[]}
            >
            <div className="mt-2 p-2">
            {(isAuth && !permission.is_anonymous) ? (
                <div className="text-center">
                    <p className="mb-2">Вы уже авторизованы.</p>
                </div>
            ) : (
                <div>      
                    {authError &&
                            <Alert
                            description={References.dictionary[authError]}
                            type="error"
                            showIcon
                          />
                    }
                    {!subdomainSettings?.default_user?.default_user_only &&
                    <div>
                    <div className="mt-1">
                        <Input 
                            type="text"
                            onChange={e => setLogin(e.target.value)}
                            placeholder="Логин"
                            prefix={<UserOutlined />}
                         />
                    </div>
                    <div className="mt-1">
                        <Input 
                            type="password"
                            onChange={e => setPassword(e.target.value)}
                            placeholder="Пароль"
                            prefix={<UnlockOutlined />}
                         />
                    </div>
                    </div>
                    }
                    <div className="text-center mt-1">
                        {isAuthorized &&
                            <LoadingOutlined className="mr-2"/>
                        }
                        {!subdomainSettings?.default_user?.default_user_only &&
                        <Button id="login-button" onClick={() => onLoginButtonClick(login, password)} icon={<LoginOutlined />}>Войти</Button>
                        }
                        {(References.hasOwnProperty('default_user') && (subdomainSettings?.default_user?.user?.length > 0 || !isPresetExist)) &&
                            <Button id="anonimus-login-button" onClick={onAnonimusLoginButtonClick} icon={<LoginOutlined />} className="ml-2">Продолжить без авторизации</Button>                        
                        }

                    </div>                    
                </div>

            )}                          
            </div>
            </Modal>

            <UserSettingsModal
                open={isShowSettingsWindow}
                onClose={onHideSettingsWindow}
            />

            {!subdomainSettings?.default_user?.default_user_only &&
            (isAuth && !permission.is_anonymous ? (
                <div
                    id="auth_btn_anchor"
                    style={{
                        position: 'absolute',
                        right: 10,
                        top: 10,
                        zIndex: 1000,
                        display: 'inline-block'
                    }}
                >
                    <Dropdown
                        menu={{
                            items: authMenuItems,
                            className: 'auth-profile-dropdown-menu'
                        }}
                        trigger={['click']}
                        placement="bottomRight"
                        align={{ offset: [0, 8] }}
                        getPopupContainer={(triggerNode) => triggerNode.parentElement || document.body}
                    >
                        <CustomButtom 
                            id="auth_btn"
                            type="circle"
                            position={{right: 0, top: 0}}
                            icon={IcoProfile}
                            tooltip={{
                                title: References.dictionary.tooltips.button_lk,
                                placement: "right"
                            }}
                            size="md"
                            handleClick={() => {}}
                        />
                    </Dropdown>
                </div>
            ) : (
                <div
                    id="auth_btn_anchor"
                    style={{
                        position: 'absolute',
                        right: 10,
                        top: 10,
                        zIndex: 1000,
                        display: 'inline-block'
                    }}
                >
                    <CustomButtom 
                        id="auth_btn"
                        type="circle"
                        position={{right: 0, top: 0}}
                        icon={IcoEnter}
                        tooltip={{
                            title: References.dictionary.tooltips.button_login,
                            placement: "right"
                        }}
                        size="md"
                        handleClick={onShowAuthWindow}
                    />
                </div>
            ))
            }

            
        </>
	)

}